module.exports = __webpack_public_path__ + "09bc73da8936c587b5a5e7122f83c013.svg";